<template>
  <div class="footer">
    <el-row type="flex" justify="space-between">
        <el-col :span="4"></el-col>
        <el-col :span="16">
            <el-row type="flex" class="row-bg" justify="space-around" al>
                <el-col :span="3">
                    <ul>
                        <li style="height:40px;font-size:16px;font-weight:400;color: #E9E9E9;" @click="$router.push('/DifferenceCart')">服务和方案</li>
                        <li style="height:20px" @click="$router.push('/DifferenceCart')">差分服务</li>
                        <li style="height:20px" @click="$router.push('/CommonProblem')">解决方案</li>
                    </ul>
                </el-col>
                <el-col :span="3">
                    <ul>
                        <li style="height:40px;font-size:16px;font-weight:400;color: #E9E9E9;" @click="$router.push('/SuccessfulCase')">成功案例</li>
                        <li style="height:20px" @click="$router.push('/Case')">管网数据采集</li>
                        <li style="height:20px" @click="$router.push('/Drainage')">智能巡检</li>
                        <li style="height:20px" @click="$router.push('/HeatSupply')">燃气泄漏检测</li>
                    </ul>
                </el-col>
                <el-col :span="3">
                    <ul>
                        <li style="height:40px;font-size:16px;font-weight:400;color: #E9E9E9;" @click="$router.push('/NewsCenter')">资讯公告</li>
                        <li style="height:20px" @click="$router.push('/NewsCenter')">新闻中心</li>
                        <li style="height:20px" @click="$router.push('/SystemBulletin')">系统公告</li>
                    </ul>
                </el-col>
                <el-col :span="3">
                    <ul>
                        <li style="height:40px;font-size:16px;font-weight:400;color: #E9E9E9;" @click="$router.push('/SoftwareDownload')">帮助中心</li>
                        <li style="height:20px" @click="$router.push('/SoftwareDownload')">软件下载</li>
<!--                        <li style="height:20px" @click="$router.push('/VideoCenter')">视频中心</li>-->
                        <li style="height:20px" @click="$router.push('/CommonProblem')">常见问题</li>
                        <li style="height:20px" @click="$router.push('/HelpDocument')">帮助文档</li>
                    </ul>
                </el-col>
                <el-col :span="3">
                    <ul>
                        <li style="height:40px;font-size:16px;font-weight:400;color: #E9E9E9;" @click="$router.push('/Beidou')">关于我们</li>
                        <li style="height:20px" @click="$router.push('/Beidou')">北斗精准服务网</li>
                        <li style="height:20px" @click="$router.push('/OperationUnit')">运营单位</li>
                        <li style="height:20px" @click="$router.push('/ContactInformation')">联系方式</li>
                    </ul>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="4">
        </el-col>
    </el-row>
    <el-row align="center" style="margin-top: 30px;font-size: 14px;display: flex;align-items: center;justify-content: center;;">
      版权所有© 北京讯腾智慧科技股份有限公司 &nbsp;&nbsp;|&nbsp;&nbsp;<a target="_blank"  href="https://beian.miit.gov.cn" style="color: #C6C6C6;" >京ICP备12028782号-5</a>
<!--      &nbsp;&nbsp;|&nbsp;&nbsp;<img src="../../assets/ga_icon.png"/>&nbsp;京公网安备11010502055212号-->
    </el-row>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'footerPage',
  data () {
    return {

    }
  },
  components: {

  }
}
</script>

<style lang="less" scoped>
.footer{
    border: none;
    padding: 20px;
    background:#082A4C;
    color: #C6C6C6;
    box-shadow:0px -1px 0px 0px rgba(229,229,229,1);
    li:hover{
        cursor: pointer;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/home-footer/home-footer.vue